import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaRocket, FaCalendarCheck, FaCalendarAlt } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

const Hero = () => {
  const [activeButton, setActiveButton] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);

  const openCalendar = () => {
    setActiveButton("calendrier");
    setShowCalendar(true);
  };

  const closeCalendar = () => {
    setShowCalendar(false);
    setActiveButton(null);
  };

  return (
    <>
      <section className="hero-section-mobile" style={styles.hero}>
        <div style={styles.gradientOverlay}></div>

        <div className="hero-content-mobile" style={styles.heroContent}>
          <h1 className="hero-title-mobile fade-in" style={styles.heroTitle}>
          <span class="gradient-text"> CINEF-EXPERTISE COMPTABLE, UN ACCOMPAGNEMENT PERSONALISE POUR LE SUCCES DE VOTRE ENTREPRISE</span> 
          </h1>
          <p className="hero-subtitle-mobile fade-in delay-1" style={styles.heroSubtitle}>
            Des experts-comptables innovants, partenaire de votre croissance
          </p>
          <div className="hero-buttons-mobile fade-in delay-2" style={styles.heroButtons}>
            <Link
              to="/businesscreationform"
              style={{
                ...styles.heroBtn,
                ...styles.btnPrimary,
                ...(activeButton === "demarrer" ? styles.activeBtnPrimary : {}),
              }}
              onClick={() => setActiveButton("demarrer")}
            >
              <FaRocket style={styles.icon} /> Démarrez votre entreprise
            </Link>
            {/* <Link
              to="/contact"
              style={{
                ...styles.heroBtn,
                ...styles.btnSecondary,
                ...(activeButton === "rendez-vous" ? styles.activeBtnSecondary : {}),
              }}
              onClick={() => setActiveButton("rendez-vous")}
            >
              <FaCalendarCheck style={styles.icon} /> Prenez rendez-vous
            </Link> */}
            <button
              style={{
                ...styles.heroBtn,
                ...styles.btnTertiary,
                ...(activeButton === "calendrier" ? styles.activeBtnTertiary : {}),
              }}
              onClick={openCalendar}
            >
              <FaCalendarAlt style={styles.icon} /> Réservez votre créneau
            </button>
          </div>
        </div>

        <div style={styles.heroImageContainer}>
          <img
            src="/assets/images/president.jpeg"
            alt="Illustration"
            style={styles.heroImage}
            className="heroImage"
          />
        </div>
      </section>

      {/* Modal pour le calendrier Google */}
      {showCalendar && (
        <div style={styles.modalOverlay} onClick={closeCalendar}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>Réservez votre rendez-vous</h3>
              <button style={styles.closeButton} onClick={closeCalendar}>
                ×
              </button>
            </div>
            <div style={styles.calendarContainer}>
              <iframe 
                src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ30HiUAglAWfWtbsla-NeJVC3PrBwr9y2_8BzlRazyhV4YI0qYb89EJJ8l2yuCAzfRQ6-0hqkcK?gv=true" 
                style={styles.calendarIframe}
                width="100%" 
                height="600" 
                frameBorder="0"
                title="Calendrier de rendez-vous"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  hero: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    height: "80vh",
    overflow: "hidden",
    paddingLeft: "5%",
    boxSizing: "border-box",
  },
  gradientOverlay: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    background: "linear-gradient(to right, rgba(0, 138, 68, 0.9), rgba(0, 138, 68, 0.2))",
    zIndex: 1,
  },
  heroContent: {
    position: "relative",
    zIndex: 2,
    width: "100%",
    maxWidth: "100%",
    color: "white",
    textAlign: "left",
    paddingRight: "5%",
    boxSizing: "border-box",
    paddingTop: "50px",
  },
  
  heroTitle: {
    fontSize: "3rem",
    fontWeight: "bold",
    marginBottom: "20px",
    textAlign: "left",
    width: "65%",
    display: "block", 
    lineHeight: "1.2",
    wordWrap: "break-word",
    maxWidth: "100%",
    '@media (max-width: 1200px)': {
      fontSize: "2.5rem",
      width: "75%",
    },
    '@media (max-width: 992px)': {
      fontSize: "2.2rem",
      width: "85%",
    },
    '@media (max-width: 768px)': {
      fontSize: "1.8rem",
      width: "100%",
      textAlign: "center",
    },
    '@media (max-width: 576px)': {
      fontSize: "1.5rem",
    },
  },
  heroSubtitle: {
    fontSize: "1.2rem",
    marginBottom: "30px",
    textAlign: "left",
    '@media (max-width: 768px)': {
      fontSize: "1rem",
      textAlign: "center",
      marginBottom: "25px",
    },
    '@media (max-width: 576px)': {
      fontSize: "0.9rem",
      marginBottom: "20px",
    },
  },
  heroButtons: {
    display: "flex",
    gap: "15px",
    flexWrap: "wrap",
    '@media (max-width: 768px)': {
      flexDirection: "column",
      alignItems: "center",
      gap: "12px",
    },
  },
  heroBtn: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 20px",
    fontSize: "1rem",
    fontWeight: "bold",
    borderRadius: "25px",
    textDecoration: "none",
    transition: "background-color 0.3s, transform 0.2s",
    border: "none",
    cursor: "pointer",
    '@media (max-width: 768px)': {
      width: "100%",
      maxWidth: "280px",
      justifyContent: "center",
      padding: "14px 20px",
    },
    '@media (max-width: 576px)': {
      fontSize: "0.9rem",
      padding: "12px 18px",
      maxWidth: "260px",
    },
  },
  btnPrimary: {
    background: "linear-gradient(45deg, #6a11cb, #2575fc)",
    color: "white",
  },
  btnSecondary: {
    background: "linear-gradient(45deg, #ff7e5f, #feb47b)",
    color: "white",
  },
  btnTertiary: {
    background: "linear-gradient(45deg, #11998e, #38ef7d)",
    color: "white",
  },
  activeBtnPrimary: {
    background: "#2575fc",
  },
  activeBtnSecondary: {
    background: "#feb47b",
  },
  activeBtnTertiary: {
    background: "#11998e",
  },
  heroImageContainer: {
    position: "absolute",
    right: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
  },
  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  icon: {
    fontSize: "1.2rem",
  },
  
  // Styles pour la modal
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    borderRadius: "15px",
    width: "90%",
    maxWidth: "900px",
    height: "80%",
    maxHeight: "700px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
    borderBottom: "1px solid #eee",
    backgroundColor: "#f8f9fa",
  },
  modalTitle: {
    margin: 0,
    color: "#333",
    fontSize: "1.5rem",
    fontWeight: "600",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "2rem",
    cursor: "pointer",
    color: "#666",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
  },
  calendarContainer: {
    flex: 1,
    overflow: "hidden",
  },
  calendarIframe: {
    border: "none",
    width: "100%",
    height: "100%",
  },
};

const animations = `
  /* Prévention du débordement horizontal */
  body {
    overflow-x: hidden;
  }
  
  /* Animation d'apparition plus douce */
  .fade-in {
    opacity: 0;
    transform: translateY(30px);
    animation: fadeInUp 1s ease-out forwards;
  }

  /* Ajout de délais pour chaque élément */
  .delay-1 { animation-delay: 0.4s; }
  .delay-2 { animation-delay: 0.8s; }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Effet flottant plus fluide */
  @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  }
  
  .heroImage {
    animation: fadeInUp 1.2s ease-out, float 5s ease-in-out infinite;
  }

  /* Effet sur les boutons */
  .heroBtn:hover {
    transform: scale(1.08);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }

  /* Effet hover sur le bouton de fermeture */
  .closeButton:hover {
    background-color: #f0f0f0;
    color: #333;
  }

  /* CSS pour améliorer l'affichage sur tous les appareils */
  
  /* Correction du décalage général */
  * {
    box-sizing: border-box;
  }
  
  section {
    overflow-x: hidden;
  }
  
  /* Large screens (desktops) */
  @media (min-width: 1200px) {
    .hero-title-mobile {
      font-size: 3.2rem !important;
    }
  }
  
  /* Medium screens (tablets en landscape) */
  @media (max-width: 1199px) and (min-width: 992px) {
    .heroTitle {
      font-size: 2.8rem !important;
      width: 70% !important;
    }
    
    .heroSubtitle {
      font-size: 1.1rem !important;
    }
  }
  
  /* Small screens (tablets en portrait) */
  @media (max-width: 991px) and (min-width: 769px) {
    .hero {
      padding-left: 30px !important;
      padding-right: 30px !important;
    }
    
    .heroTitle {
      font-size: 2.4rem !important;
      width: 85% !important;
    }
    
    .heroSubtitle {
      font-size: 1.05rem !important;
    }
    
    .heroBtn {
      padding: 13px 18px !important;
      font-size: 0.95rem !important;
    }
  }
  
  /* Mobile screens */
  @media (max-width: 768px) {
    .hero-section-mobile {
      justify-content: center !important;
      text-align: center !important;
      padding: 0 10px !important;
      height: 70vh !important;
      margin: 0 !important;
      overflow-x: hidden !important;
    }
    
    .hero-content-mobile {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 10px !important;
      text-align: center !important;
      margin: 0 !important;
      box-sizing: border-box !important;
    }
    
    .hero-title-mobile {
      font-size: 1.9rem !important;
      width: 100% !important;
      text-align: center !important;
      margin-bottom: 15px !important;
      padding: 0 !important;
      word-wrap: break-word !important;
      hyphens: auto !important;
    }
    
    .hero-subtitle-mobile {
      font-size: 1rem !important;
      text-align: center !important;
      margin-bottom: 25px !important;
      padding: 0 !important;
    }
    
    .hero-buttons-mobile {
      justify-content: center !important;
      flex-direction: column !important;
      align-items: center !important;
      gap: 12px !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .hero-buttons-mobile a {
      width: calc(100% - 20px) !important;
      max-width: 280px !important;
      justify-content: center !important;
      padding: 14px 20px !important;
      margin: 0 auto !important;
      box-sizing: border-box !important;
    }

    .modalContent {
      width: 95% !important;
      height: 90% !important;
      margin: 10px !important;
    }

    .modalTitle {
      font-size: 1.2rem !important;
    }
  }
  
  /* Very small screens */
  @media (max-width: 576px) {
    .hero-section-mobile {
      height: 60vh !important;
      min-height: 500px !important;
      padding: 0 5px !important;
    }
    
    .hero-content-mobile {
      padding: 0 5px !important;
    }
    
    .hero-title-mobile {
      font-size: 1.6rem !important;
      line-height: 1.3 !important;
    }
    
    .hero-subtitle-mobile {
      font-size: 0.9rem !important;
      margin-bottom: 20px !important;
    }
    
    .hero-buttons-mobile a {
      font-size: 0.9rem !important;
      padding: 12px 18px !important;
      max-width: 260px !important;
      width: calc(100% - 10px) !important;
    }
    
    .modalContent {
      width: 98% !important;
      height: 95% !important;
      margin: 5px !important;
    }
    
    .closeButton {
      width: 35px !important;
      height: 35px !important;
      font-size: 1.5rem !important;
    }
  }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = animations;
document.head.appendChild(styleSheet);

export default Hero;